// @ts-nocheck
import * as React from "react";

const CompareFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M16.443 3.836a1.015 1.015 0 0 0-1.509 0 1.208 1.208 0 0 0 0 1.622l2.444 2.615H5.063C4.476 8.073 4 8.584 4 9.215c0 .63.476 1.142 1.063 1.142h14.876c.43-.002.815-.281.978-.708a1.206 1.206 0 0 0-.223-1.245l-4.25-4.568Zm3.494 8.807H5.061c-.43.002-.815.282-.978.708-.166.425-.078.916.223 1.244l4.25 4.567c.2.217.472.338.755.338.284 0 .555-.121.755-.338.2-.214.314-.506.314-.81 0-.305-.113-.597-.314-.811l-2.444-2.615h12.315c.587 0 1.063-.51 1.063-1.141 0-.63-.476-1.142-1.063-1.142Z"
            />
        </svg>
    );
};

export default React.memo(CompareFill);
